import authService from '../utils/auth.js';
import { getApiBaseUrl } from '../utils/apiBase.js';

export class NovaMatchIntegrationError extends Error {
  constructor(message, { code, status } = {}) {
    super(message);
    this.name = 'NovaMatchIntegrationError';
    this.code = code;
    this.status = status;
  }
}

export async function autoLoginNovaMatch() {
  const response = await fetch(`${getApiBaseUrl()}/api/integrations/novamatch/auto-login`, {
    method: 'POST',
    headers: authService.getAuthHeaders()
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new NovaMatchIntegrationError(
      data.message || `Failed to open NovaMatch (${response.status})`,
      { code: data.code, status: response.status }
    );
  }

  return data;
}
